import { isClaimCorn } from './serviceCorns/claims.js';
import { isJobCorn } from '@eigtech/restoration-types';
export const getEntityTypeFromCorn = (corn) => {
    if (isClaimCorn(corn))
        return 'claim';
    if (isJobCorn(corn))
        return 'job';
    return undefined;
};
